import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { Error401Component } from './error-401.component'

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [Error401Component]
})
export class Error401Module {}